import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import {
	ButtonComponent,
	Carousel2Component,
	Carousel2ItemComponent,
	CustomWindow,
	PopupComponent,
	PopupTargetDirective,
	RecipeImpressionArgs,
	SvgIconComponent,
	WINDOW
} from '@woolworthsnz/styleguide';
import { createRecipeImpressionArgs } from '../../helpers';
import { getRecipePath } from '../../helpers/recipe-path';
import { LatestMealPlan, RecipeStampLocal, StampType } from '../../models';
import { Stamp } from '../../models/stamp.interface';
import { PrintMealPlanRecipesComponent } from '../print-meal-plan-recipes/print-meal-plan-recipes.component';
import { StampComponent } from '../stamp/stamp.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
	selector: 'recipe-latest-meal-plan',
	templateUrl: './latest-meal-plan.component.html',
	styleUrls: ['./latest-meal-plan.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [Carousel2Component, NgFor, Carousel2ItemComponent, StampComponent, ButtonComponent, NgIf, SvgIconComponent, PopupComponent, PopupTargetDirective, PrintMealPlanRecipesComponent]
})
export class LatestMealPlanComponent {
	@Input() public latestMealPlan!: LatestMealPlan;
	@Input() public columns: number;
	@Input() public viewInvoiceDisabled = false;
	@Output() public saveOrUnsaveRecipe = new EventEmitter<{ id: number; isSaved: boolean }>();
	@Output() public viewInvoice = new EventEmitter<number>();

	/**
	 * Curently we get the wrong fulfilmentLocation from the order-confirmation api so we can't display the
	 * fulfilment information correctly. Todo: fix the api: CRJI-962
	 */
	public isFulfilmentDataFixed = false;
	public stampType = StampType.meal;
	public carouselName = 'latest-meal-plan';
	public showPrintableMealPlan = false;

	constructor(@Inject(WINDOW) private window: CustomWindow) { }

	public get recipeIdList(): number[] {
		return this.latestMealPlan.mealPlan.meals.map(({ recipe }) => recipe.id);
	}

	public getRecipePath(stamp: Stamp): string {
		return getRecipePath(stamp.recipe.mealTimes, stamp.recipe.title, stamp.recipe.id);
	}

	public printMealPlanRecipes(): void {
		this.window.print();
		this.showPrintableMealPlan = false;
	}

	public downloadPackingSlipPDF(): void {
		// How to get link to PDF?
	}

	public displayPrintableMealPlan(): void {
		this.showPrintableMealPlan = true;
	}

	public handleSaveOrUnsaveRecipe(stamp: Stamp): void {
		this.saveOrUnsaveRecipe.emit({ id: stamp.recipe.id, isSaved: !!stamp.recipe.saved });
	}

	public getRecipeImpressionArgs(recipe: RecipeStampLocal, index: number): RecipeImpressionArgs {
		return createRecipeImpressionArgs(recipe, index + 1, this.carouselName);
	}
}
